/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripLiveSummaryOpenTrip: "trip-live-summary-open-trip",
} as const;
